var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Order Information - Products Unselected Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.03755098,15.1020408 L4.16326526,20.0000001 L9.06122447,18.1257143 L16.682449,10.4979592 L13.6653061,7.4808163 L6.03755098,15.1020408 Z M8.68897957,17.5542857 L5.30612241,18.8571429 L6.61224486,15.4742857 L13.6653061,8.41142855 L15.7518368,10.4979592 L8.68897957,17.5542857 Z M19.2163266,4.94693873 C18.8188793,4.54933949 18.2797339,4.32595778 17.7175511,4.32595778 C17.1553682,4.32595778 16.6162228,4.54933949 16.2187755,4.94693873 L14.6122449,6.55999997 L17.6032653,9.55102039 L19.2163266,7.93795916 C20.0399552,7.11105254 20.0399552,5.77384535 19.2163266,4.94693873 Z M18.7559184,7.4808163 L17.6032653,8.63346937 L15.5330612,6.55999997 L16.6857143,5.4073469 C17.2642475,4.87306215 18.1615236,4.89124774 18.7179332,5.44853501 C19.2743429,6.00582228 19.2911143,6.90312592 18.7559184,7.4808163 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Order-Information---Products-Unselected-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.855422247
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC41-Icons-/-Outline-/-01-General-/-Pencil"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pencil",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD35-Color-/-Blue-/-3-Dark",
    mask: "url(#mask-2)",
    fill: "#4A4A49",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Dark-Blue",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_Icon.74b4e14c1d9b0d874deda2bfe488fe3b.svg";
export { ForwardRef as ReactComponent };